import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/braindates/top-right-corner-shard@2x.png")